// 📁 src/api/productAPI.js

const API_BASE_URL = 'https://stage-apiv2.myearth.id'; // Replace with your backend base URL
//const API_BASE_URL = 'http://localhost:3030'; // Replace with your backend base URL

// ✅ Create a new product
export const createProduct = async (productData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to create product');
    return result;
  } catch (err) {
    console.error('Create Product Error:', err);
    return null;
  }
};

// ✅ Get all products (for all users)
export const getAllProducts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/products`);
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to fetch products');
    return result;
  } catch (err) {
    console.error('Get All Products Error:', err);
    return [];
  }
};

// ✅ Get products by userId
export const getProductsByUserId = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products/user/${userId}`);
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to fetch user products');
    return result;
  } catch (err) {
    console.error('Get User Products Error:', err);
    return [];
  }
};

// ✅ Delete product by userId and productId
export const deleteProduct = async (userId, productId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products/${userId}/${productId}`, {
      method: 'DELETE',
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to delete product');
    return result;
  } catch (err) {
    console.error('Delete Product Error:', err);
    return null;
  }
};
